import { AccredibleCountry } from '@accredible-frontend-v2/models';

export const CountriesAndStates: AccredibleCountry[] = [
  { code: 'AF', name: 'Afghanistan' },
  { code: 'AL', name: 'Albania' },
  { code: 'DZ', name: 'Algeria' },
  { code: 'AD', name: 'Andorra' },
  { code: 'AO', name: 'Angola' },
  { code: 'AG', name: 'Antigua And Barbuda' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AM', name: 'Armenia' },
  {
    code: 'AU',
    name: 'Australia',
    states: [
      { code: 'AU-NSW', name: 'New South Wales' },
      { code: 'AU-QLD', name: 'Queensland' },
      { code: 'AU-SA', name: 'South Australia' },
      { code: 'AU-TAS', name: 'Tasmania' },
      { code: 'AU-VIC', name: 'Victoria' },
      { code: 'AU-WA', name: 'Western Australia' },
    ],
  },
  {
    code: 'AT',
    name: 'Austria',
    states: [
      { code: 'AT-1', name: 'Burgenland' },
      { code: 'AT-2', name: 'Kärnten' },
      { code: 'AT-3', name: 'Niederösterreich' },
      { code: 'AT-4', name: 'Oberösterreich' },
      { code: 'AT-5', name: 'Salzburg' },
      { code: 'AT-6', name: 'Steiermark' },
      { code: 'AT-7', name: 'Tirol' },
      { code: 'AT-8', name: 'Vorarlberg' },
      { code: 'AT-9', name: 'Wien' },
    ],
  },
  { code: 'AZ', name: 'Azerbaijan' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'BH', name: 'Bahrain' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BB', name: 'Barbados' },
  { code: 'BY', name: 'Belarus' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BZ', name: 'Belize' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BT', name: 'Bhutan' },
  { code: 'BO', name: 'Bolivia, Plurinational State Of' },
  { code: 'BA', name: 'Bosnia And Herzegovina' },
  { code: 'BW', name: 'Botswana' },
  {
    code: 'BR',
    name: 'Brazil',
    states: [
      { code: 'BR-AC', name: 'Acre' },
      { code: 'BR-AL', name: 'Alagoas' },
      { code: 'BR-AP', name: 'Amapá' },
      { code: 'BR-AM', name: 'Amazonas' },
      { code: 'BR-BA', name: 'Bahia' },
      { code: 'BR-CE', name: 'Ceará' },
      { code: 'BR-ES', name: 'Espírito Santo' },
      { code: 'BR-GO', name: 'Goiás' },
      { code: 'BR-MA', name: 'Maranhão' },
      { code: 'BR-MT', name: 'Mato Grosso' },
      { code: 'BR-MS', name: 'Mato Grosso do Sul' },
      { code: 'BR-MG', name: 'Minas Gerais' },
      { code: 'BR-PR', name: 'Paraná' },
      { code: 'BR-PB', name: 'Paraíba' },
      { code: 'BR-PA', name: 'Pará' },
      { code: 'BR-PE', name: 'Pernambuco' },
      { code: 'BR-PI', name: 'Piauí' },
      { code: 'BR-RN', name: 'Rio Grande do Norte' },
      { code: 'BR-RS', name: 'Rio Grande do Sul' },
      { code: 'BR-RJ', name: 'Rio de Janeiro' },
      { code: 'BR-RO', name: 'Rondônia' },
      { code: 'BR-RR', name: 'Roraima' },
      { code: 'BR-SC', name: 'Santa Catarina' },
      { code: 'BR-SE', name: 'Sergipe' },
      { code: 'BR-SP', name: 'São Paulo' },
      { code: 'BR-TO', name: 'Tocantins' },
    ],
  },
  { code: 'BN', name: 'Brunei Darussalam' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BI', name: 'Burundi' },
  { code: 'CV', name: 'Cabo Verde' },
  { code: 'KH', name: 'Cambodia' },
  { code: 'CM', name: 'Cameroon' },
  { code: 'CA', name: 'Canada' },
  { code: 'CF', name: 'Central African Republic' },
  { code: 'TD', name: 'Chad' },
  { code: 'CL', name: 'Chile' },
  { code: 'CN', name: 'China' },
  { code: 'CO', name: 'Colombia' },
  { code: 'KM', name: 'Comoros' },
  { code: 'CG', name: 'Congo' },
  { code: 'CD', name: 'Congo, Democratic Republic Of The' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'HR', name: 'Croatia' },
  { code: 'CU', name: 'Cuba' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czechia' },
  { code: 'CI', name: "Côte D'ivoire" },
  { code: 'DK', name: 'Denmark' },
  { code: 'DJ', name: 'Djibouti' },
  { code: 'DM', name: 'Dominica' },
  { code: 'DO', name: 'Dominican Republic' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EG', name: 'Egypt' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'GQ', name: 'Equatorial Guinea' },
  { code: 'ER', name: 'Eritrea' },
  { code: 'EE', name: 'Estonia' },
  { code: 'SZ', name: 'Eswatini' },
  { code: 'ET', name: 'Ethiopia' },
  { code: 'FJ', name: 'Fiji' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'France' },
  { code: 'GA', name: 'Gabon' },
  { code: 'GM', name: 'Gambia' },
  { code: 'GE', name: 'Georgia' },
  { code: 'DE', name: 'Germany' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GR', name: 'Greece' },
  { code: 'GD', name: 'Grenada' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GW', name: 'Guinea Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HT', name: 'Haiti' },
  { code: 'VA', name: 'Holy See' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HU', name: 'Hungary' },
  { code: 'IS', name: 'Iceland' },
  {
    code: 'IN',
    name: 'India',
    states: [
      { code: 'IN-AP', name: 'Andhra Pradesh' },
      { code: 'IN-AR', name: 'Arunāchal Pradesh' },
      { code: 'IN-AS', name: 'Assam' },
      { code: 'IN-BR', name: 'Bihār' },
      { code: 'IN-CG', name: 'Chhattīsgarh' },
      { code: 'IN-GA', name: 'Goa' },
      { code: 'IN-GJ', name: 'Gujarāt' },
      { code: 'IN-HR', name: 'Haryāna' },
      { code: 'IN-HP', name: 'Himāchal Pradesh' },
      { code: 'IN-JH', name: 'Jhārkhand' },
      { code: 'IN-KA', name: 'Karnātaka' },
      { code: 'IN-KL', name: 'Kerala' },
      { code: 'IN-MP', name: 'Madhya Pradesh' },
      { code: 'IN-MH', name: 'Mahārāshtra' },
      { code: 'IN-MN', name: 'Manipur' },
      { code: 'IN-ML', name: 'Meghālaya' },
      { code: 'IN-MZ', name: 'Mizoram' },
      { code: 'IN-NL', name: 'Nāgāland' },
      { code: 'IN-OD', name: 'Odisha' },
      { code: 'IN-PB', name: 'Punjab' },
      { code: 'IN-RJ', name: 'Rājasthān' },
      { code: 'IN-SK', name: 'Sikkim' },
      { code: 'IN-TN', name: 'Tamil Nādu' },
      { code: 'IN-TS', name: 'Telangāna' },
      { code: 'IN-TR', name: 'Tripura' },
      { code: 'IN-UP', name: 'Uttar Pradesh' },
      { code: 'IN-UK', name: 'Uttarākhand' },
      { code: 'IN-WB', name: 'West Bengal' },
    ],
  },
  { code: 'ID', name: 'Indonesia' },
  { code: 'IR', name: 'Iran, Islamic Republic Of' },
  { code: 'IQ', name: 'Iraq' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IL', name: 'Israel' },
  { code: 'IT', name: 'Italy' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'JP', name: 'Japan' },
  { code: 'JO', name: 'Jordan' },
  { code: 'KZ', name: 'Kazakhstan' },
  { code: 'KE', name: 'Kenya' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'KP', name: "Korea, Democratic People's Republic Of" },
  { code: 'KR', name: 'Korea, Republic Of' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'KG', name: 'Kyrgyzstan' },
  { code: 'LA', name: "Lao People's Democratic Republic" },
  { code: 'LV', name: 'Latvia' },
  { code: 'LB', name: 'Lebanon' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LR', name: 'Liberia' },
  { code: 'LY', name: 'Libya' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MG', name: 'Madagascar' },
  { code: 'MW', name: 'Malawi' },
  {
    code: 'MY',
    name: 'Malaysia',
    states: [
      { code: 'MY-01', name: 'Johor' },
      { code: 'MY-02', name: 'Kedah' },
      { code: 'MY-03', name: 'Kelantan' },
      { code: 'MY-04', name: 'Melaka' },
      { code: 'MY-05', name: 'Negeri Sembilan' },
      { code: 'MY-06', name: 'Pahang' },
      { code: 'MY-08', name: 'Perak' },
      { code: 'MY-09', name: 'Perlis' },
      { code: 'MY-07', name: 'Pulau Pinang' },
      { code: 'MY-12', name: 'Sabah' },
      { code: 'MY-13', name: 'Sarawak' },
      { code: 'MY-10', name: 'Selangor' },
      { code: 'MY-11', name: 'Terengganu' },
    ],
  },
  { code: 'MV', name: 'Maldives' },
  { code: 'ML', name: 'Mali' },
  { code: 'MT', name: 'Malta' },
  { code: 'MH', name: 'Marshall Islands' },
  { code: 'MR', name: 'Mauritania' },
  { code: 'MU', name: 'Mauritius' },
  {
    code: 'MX',
    name: 'Mexico',
    states: [
      { code: 'MX-AGU', name: 'Aguascalientes' },
      { code: 'MX-BCN', name: 'Baja California' },
      { code: 'MX-BCS', name: 'Baja California Sur' },
      { code: 'MX-CAM', name: 'Campeche' },
      { code: 'MX-CHP', name: 'Chiapas' },
      { code: 'MX-CHH', name: 'Chihuahua' },
      { code: 'MX-COA', name: 'Coahuila de Zaragoza' },
      { code: 'MX-COL', name: 'Colima' },
      { code: 'MX-DUR', name: 'Durango' },
      { code: 'MX-GUA', name: 'Guanajuato' },
      { code: 'MX-GRO', name: 'Guerrero' },
      { code: 'MX-HID', name: 'Hidalgo' },
      { code: 'MX-JAL', name: 'Jalisco' },
      { code: 'MX-MIC', name: 'Michoacán de Ocampo' },
      { code: 'MX-MOR', name: 'Morelos' },
      { code: 'MX-MEX', name: 'México' },
      { code: 'MX-NAY', name: 'Nayarit' },
      { code: 'MX-NLE', name: 'Nuevo León' },
      { code: 'MX-OAX', name: 'Oaxaca' },
      { code: 'MX-PUE', name: 'Puebla' },
      { code: 'MX-QUE', name: 'Querétaro' },
      { code: 'MX-ROO', name: 'Quintana Roo' },
      { code: 'MX-SLP', name: 'San Luis Potosí' },
      { code: 'MX-SIN', name: 'Sinaloa' },
      { code: 'MX-SON', name: 'Sonora' },
      { code: 'MX-TAB', name: 'Tabasco' },
      { code: 'MX-TAM', name: 'Tamaulipas' },
      { code: 'MX-TLA', name: 'Tlaxcala' },
      { code: 'MX-VER', name: 'Veracruz de Ignacio de la Llave' },
      { code: 'MX-YUC', name: 'Yucatán' },
      { code: 'MX-ZAC', name: 'Zacatecas' },
    ],
  },
  {
    code: 'FM',
    name: 'Micronesia, Federated States Of',
    states: [
      { code: 'FM-TRK', name: 'Chuuk' },
      { code: 'FM-KSA', name: 'Kosrae' },
      { code: 'FM-PNI', name: 'Pohnpei' },
      { code: 'FM-YAP', name: 'Yap' },
    ],
  },
  { code: 'MD', name: 'Moldova, Republic Of' },
  { code: 'MC', name: 'Monaco' },
  { code: 'MN', name: 'Mongolia' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'MA', name: 'Morocco' },
  { code: 'MZ', name: 'Mozambique' },
  {
    code: 'MM',
    name: 'Myanmar',
    states: [
      { code: 'MM-14', name: 'Chin' },
      { code: 'MM-11', name: 'Kachin' },
      { code: 'MM-12', name: 'Kayah' },
      { code: 'MM-13', name: 'Kayin' },
      { code: 'MM-15', name: 'Mon' },
      { code: 'MM-16', name: 'Rakhine' },
      { code: 'MM-17', name: 'Shan' },
    ],
  },
  { code: 'NA', name: 'Namibia' },
  { code: 'NR', name: 'Nauru' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NL', name: 'Netherlands, Kingdom Of The' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NE', name: 'Niger' },
  {
    code: 'NG',
    name: 'Nigeria',
    states: [
      { code: 'NG-AB', name: 'Abia' },
      { code: 'NG-AD', name: 'Adamawa' },
      { code: 'NG-AK', name: 'Akwa Ibom' },
      { code: 'NG-AN', name: 'Anambra' },
      { code: 'NG-BA', name: 'Bauchi' },
      { code: 'NG-BY', name: 'Bayelsa' },
      { code: 'NG-BE', name: 'Benue' },
      { code: 'NG-BO', name: 'Borno' },
      { code: 'NG-CR', name: 'Cross River' },
      { code: 'NG-DE', name: 'Delta' },
      { code: 'NG-EB', name: 'Ebonyi' },
      { code: 'NG-ED', name: 'Edo' },
      { code: 'NG-EK', name: 'Ekiti' },
      { code: 'NG-EN', name: 'Enugu' },
      { code: 'NG-GO', name: 'Gombe' },
      { code: 'NG-IM', name: 'Imo' },
      { code: 'NG-JI', name: 'Jigawa' },
      { code: 'NG-KD', name: 'Kaduna' },
      { code: 'NG-KN', name: 'Kano' },
      { code: 'NG-KT', name: 'Katsina' },
      { code: 'NG-KE', name: 'Kebbi' },
      { code: 'NG-KO', name: 'Kogi' },
      { code: 'NG-KW', name: 'Kwara' },
      { code: 'NG-LA', name: 'Lagos' },
      { code: 'NG-NA', name: 'Nasarawa' },
      { code: 'NG-NI', name: 'Niger' },
      { code: 'NG-OG', name: 'Ogun' },
      { code: 'NG-ON', name: 'Ondo' },
      { code: 'NG-OS', name: 'Osun' },
      { code: 'NG-OY', name: 'Oyo' },
      { code: 'NG-PL', name: 'Plateau' },
      { code: 'NG-RI', name: 'Rivers' },
      { code: 'NG-SO', name: 'Sokoto' },
      { code: 'NG-TA', name: 'Taraba' },
      { code: 'NG-YO', name: 'Yobe' },
      { code: 'NG-ZA', name: 'Zamfara' },
    ],
  },
  { code: 'MK', name: 'North Macedonia' },
  { code: 'NO', name: 'Norway' },
  { code: 'OM', name: 'Oman' },
  { code: 'PK', name: 'Pakistan' },
  {
    code: 'PW',
    name: 'Palau',
    states: [
      { code: 'PW-002', name: 'Aimeliik' },
      { code: 'PW-004', name: 'Airai' },
      { code: 'PW-010', name: 'Angaur' },
      { code: 'PW-050', name: 'Hatohobei' },
      { code: 'PW-100', name: 'Kayangel' },
      { code: 'PW-150', name: 'Koror' },
      { code: 'PW-212', name: 'Melekeok' },
      { code: 'PW-214', name: 'Ngaraard' },
      { code: 'PW-218', name: 'Ngarchelong' },
      { code: 'PW-222', name: 'Ngardmau' },
      { code: 'PW-224', name: 'Ngatpang' },
      { code: 'PW-226', name: 'Ngchesar' },
      { code: 'PW-227', name: 'Ngeremlengui' },
      { code: 'PW-228', name: 'Ngiwal' },
      { code: 'PW-350', name: 'Peleliu' },
      { code: 'PW-370', name: 'Sonsorol' },
    ],
  },
  { code: 'PA', name: 'Panama' },
  { code: 'PG', name: 'Papua New Guinea' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Peru' },
  { code: 'PH', name: 'Philippines' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'QA', name: 'Qatar' },
  { code: 'RO', name: 'Romania' },
  { code: 'RU', name: 'Russian Federation' },
  { code: 'RW', name: 'Rwanda' },
  {
    code: 'KN',
    name: 'Saint Kitts And Nevis',
    states: [
      { code: 'KN-N', name: 'Nevis' },
      { code: 'KN-K', name: 'Saint Kitts' },
    ],
  },
  { code: 'LC', name: 'Saint Lucia' },
  { code: 'VC', name: 'Saint Vincent And The Grenadines' },
  { code: 'WS', name: 'Samoa' },
  { code: 'SM', name: 'San Marino' },
  { code: 'ST', name: 'Sao Tome And Principe' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'SN', name: 'Senegal' },
  { code: 'RS', name: 'Serbia' },
  { code: 'SC', name: 'Seychelles' },
  { code: 'SL', name: 'Sierra Leone' },
  { code: 'SG', name: 'Singapore' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'SB', name: 'Solomon Islands' },
  { code: 'SO', name: 'Somalia' },
  { code: 'ZA', name: 'South Africa' },
  {
    code: 'SS',
    name: 'South Sudan',
    states: [
      { code: 'SS-EC', name: 'Central Equatoria' },
      { code: 'SS-EE', name: 'Eastern Equatoria' },
      { code: 'SS-JG', name: 'Jonglei' },
      { code: 'SS-LK', name: 'Lakes' },
      { code: 'SS-BN', name: 'Northern Bahr el Ghazal' },
      { code: 'SS-UY', name: 'Unity' },
      { code: 'SS-NU', name: 'Upper Nile' },
      { code: 'SS-WR', name: 'Warrap' },
      { code: 'SS-BW', name: 'Western Bahr el Ghazal' },
      { code: 'SS-EW', name: 'Western Equatoria' },
    ],
  },
  { code: 'ES', name: 'Spain' },
  { code: 'LK', name: 'Sri Lanka' },
  {
    code: 'SD',
    name: 'Sudan',
    states: [
      { code: 'SD-NB', name: 'Blue Nile' },
      { code: 'SD-DC', name: 'Central Darfur' },
      { code: 'SD-DE', name: 'East Darfur' },
      { code: 'SD-GD', name: 'Gedaref' },
      { code: 'SD-GZ', name: 'Gezira' },
      { code: 'SD-KA', name: 'Kassala' },
      { code: 'SD-KH', name: 'Khartoum' },
      { code: 'SD-DN', name: 'North Darfur' },
      { code: 'SD-KN', name: 'North Kordofan' },
      { code: 'SD-NO', name: 'Northern' },
      { code: 'SD-RS', name: 'Red Sea' },
      { code: 'SD-NR', name: 'River Nile' },
      { code: 'SD-SI', name: 'Sennar' },
      { code: 'SD-DS', name: 'South Darfur' },
      { code: 'SD-KS', name: 'South Kordofan' },
      { code: 'SD-DW', name: 'West Darfur' },
      { code: 'SD-GK', name: 'West Kordofan' },
      { code: 'SD-NW', name: 'White Nile' },
    ],
  },
  { code: 'SR', name: 'Suriname' },
  { code: 'SE', name: 'Sweden' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'SY', name: 'Syrian Arab Republic' },
  { code: 'TJ', name: 'Tajikistan' },
  { code: 'TZ', name: 'Tanzania, United Republic Of' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TL', name: 'Timor Leste' },
  { code: 'TG', name: 'Togo' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TT', name: 'Trinidad And Tobago' },
  { code: 'TN', name: 'Tunisia' },
  { code: 'TM', name: 'Turkmenistan' },
  { code: 'TV', name: 'Tuvalu' },
  { code: 'TR', name: 'Türki̇ye' },
  { code: 'UG', name: 'Uganda' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'GB', name: 'United Kingdom Of Great Britain And Northern Ireland' },
  {
    code: 'US',
    name: 'United States Of America',
    states: [
      { code: 'US-AL', name: 'Alabama' },
      { code: 'US-AK', name: 'Alaska' },
      { code: 'US-AZ', name: 'Arizona' },
      { code: 'US-AR', name: 'Arkansas' },
      { code: 'US-CA', name: 'California' },
      { code: 'US-CO', name: 'Colorado' },
      { code: 'US-CT', name: 'Connecticut' },
      { code: 'US-DE', name: 'Delaware' },
      { code: 'US-FL', name: 'Florida' },
      { code: 'US-GA', name: 'Georgia' },
      { code: 'US-HI', name: 'Hawaii' },
      { code: 'US-ID', name: 'Idaho' },
      { code: 'US-IL', name: 'Illinois' },
      { code: 'US-IN', name: 'Indiana' },
      { code: 'US-IA', name: 'Iowa' },
      { code: 'US-KS', name: 'Kansas' },
      { code: 'US-KY', name: 'Kentucky' },
      { code: 'US-LA', name: 'Louisiana' },
      { code: 'US-ME', name: 'Maine' },
      { code: 'US-MD', name: 'Maryland' },
      { code: 'US-MA', name: 'Massachusetts' },
      { code: 'US-MI', name: 'Michigan' },
      { code: 'US-MN', name: 'Minnesota' },
      { code: 'US-MS', name: 'Mississippi' },
      { code: 'US-MO', name: 'Missouri' },
      { code: 'US-MT', name: 'Montana' },
      { code: 'US-NE', name: 'Nebraska' },
      { code: 'US-NV', name: 'Nevada' },
      { code: 'US-NH', name: 'New Hampshire' },
      { code: 'US-NJ', name: 'New Jersey' },
      { code: 'US-NM', name: 'New Mexico' },
      { code: 'US-NY', name: 'New York' },
      { code: 'US-NC', name: 'North Carolina' },
      { code: 'US-ND', name: 'North Dakota' },
      { code: 'US-OH', name: 'Ohio' },
      { code: 'US-OK', name: 'Oklahoma' },
      { code: 'US-OR', name: 'Oregon' },
      { code: 'US-PA', name: 'Pennsylvania' },
      { code: 'US-RI', name: 'Rhode Island' },
      { code: 'US-SC', name: 'South Carolina' },
      { code: 'US-SD', name: 'South Dakota' },
      { code: 'US-TN', name: 'Tennessee' },
      { code: 'US-TX', name: 'Texas' },
      { code: 'US-UT', name: 'Utah' },
      { code: 'US-VT', name: 'Vermont' },
      { code: 'US-VA', name: 'Virginia' },
      { code: 'US-WA', name: 'Washington' },
      { code: 'US-WV', name: 'West Virginia' },
      { code: 'US-WI', name: 'Wisconsin' },
      { code: 'US-WY', name: 'Wyoming' },
    ],
  },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistan' },
  { code: 'VU', name: 'Vanuatu' },
  {
    code: 'VE',
    name: 'Venezuela, Bolivarian Republic Of',
    states: [
      { code: 'VE-Z', name: 'Amazonas' },
      { code: 'VE-B', name: 'Anzoátegui' },
      { code: 'VE-C', name: 'Apure' },
      { code: 'VE-D', name: 'Aragua' },
      { code: 'VE-E', name: 'Barinas' },
      { code: 'VE-F', name: 'Bolívar' },
      { code: 'VE-G', name: 'Carabobo' },
      { code: 'VE-H', name: 'Cojedes' },
      { code: 'VE-Y', name: 'Delta Amacuro' },
      { code: 'VE-I', name: 'Falcón' },
      { code: 'VE-J', name: 'Guárico' },
      { code: 'VE-X', name: 'La Guaira' },
      { code: 'VE-K', name: 'Lara' },
      { code: 'VE-M', name: 'Miranda' },
      { code: 'VE-N', name: 'Monagas' },
      { code: 'VE-L', name: 'Mérida' },
      { code: 'VE-O', name: 'Nueva Esparta' },
      { code: 'VE-P', name: 'Portuguesa' },
      { code: 'VE-R', name: 'Sucre' },
      { code: 'VE-T', name: 'Trujillo' },
      { code: 'VE-S', name: 'Táchira' },
      { code: 'VE-U', name: 'Yaracuy' },
      { code: 'VE-V', name: 'Zulia' },
    ],
  },
  { code: 'VN', name: 'Viet Nam' },
  { code: 'YE', name: 'Yemen' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' },
];
